import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { withStyles, Button, CircularProgress, Dialog, FormControlLabel, Checkbox } from '@material-ui/core';
import TopUpUnit from './TopupUnit';
import * as actions from "../store/prepaidBalanceActions";
import { connect } from "react-redux";
import AppLogoLoading from "../../../sc-logo";
import { hasPermission } from '../../../sc-utilities';

const styles = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingBottom: theme.spacing(3),
    },
    buttonDiv: {
        display: 'inline',
        width: 'auto',
    },
    row: {
        display: 'grid',
        placeItems: 'center',
        width: "auto",
    },
    submit: {
        width: '13rem',
        marginLeft: theme.spacing(2),
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    cancel: {
        width: "13rem",
    },
    error: {
        color: 'red',
        fontSize: "14px",
    },
    buttons: {
        marginTop: "30px"
    },
    loadingScreen: {
        backgroundColor: "transparent",
        boxShadow: "none",
    },
});

const TopUpForm = props => {
    const {
        classes,
        formSettings,
        initialValues,
        handleSubmit,
        accountID,
        translations,
        onListTopupPriceList,
        activeCustomerID,
        permissions
    } = props;

    const [topupPriceList, setTopupPriceList] = useState([]);
    const [isDisabled, setIsDisabled] = useState(true);
    const [loading, setLoading] = useState(true);

    const getTopUpPriceList = async () => {
        const result = await onListTopupPriceList({ ActiveAccountID: accountID, ActiveCustomerID: activeCustomerID });
        setTopupPriceList({ ...result, currency: [{ from: 0.1, to: '', price: 1, }] });

        if (!result || (result.mobile?.length === 0 && result.mobile_diagnose?.length === 0 && result.mobile_check?.length === 0 && result.remote?.length === 0 && result.work?.length === 0 && result.work_diagnose?.length === 0 && result.work_check?.length === 0 && result.work_verifier?.length === 0 && result.mobile_verifier?.length === 0)) {
            setIsDisabled(true);
        } else {
            setIsDisabled(false);
        }
        setLoading(false);
    };

    useEffect(() => {
        getTopUpPriceList();
        // eslint-disable-next-line
    }, [accountID, activeCustomerID]);

    return (
        <>
            {!loading && <Formik
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(false);
                }}
                enableReinitialize
                validationSchema={formSettings.Validation}
            >
                {formikProps => {
                    const { values, isValid, dirty, errors, touched, isSubmitting, handleSubmit, setValues, handleChange } = formikProps;
                    const error = errors && (errors["Mobile Erasure"]?.amount || errors["Mobile Erasure Lite"]?.amount || errors["Mobile Diagnose"]?.amount || errors["Mobile Check"]?.amount || errors["Remote"]?.amount || errors["Work Erasure"]?.amount || errors["Work Diagnose"]?.amount || errors["Work Check"]?.amount || errors["Work Erasure Verification"]?.amount || errors["Mobile Erasure Verification"]?.amount || errors["Watch Erasure"]?.amount || errors["Watch Diagnose"]?.amount || errors["Watch Check"]?.amount || errors["Headphone Diagnose"]?.amount || errors["Headphone Check"]?.amount);
                    const currencyError = errors && errors["Currency"]?.amount;

                    const propsToPass = {
                        errors,
                        accountID,
                        touched,
                        values,
                        translations,
                        setValues,
                        setIsDisabled,
                        topupPriceList
                    }

                    const handlePromotionCredits = (e) => {
                        if (e.target.checked) {
                            setValues({
                                ...values,
                                'Mobile Erasure': { amount: 0, price: 0, total: 0 },
                                'Mobile Erasure Lite': { amount: 0, price: 0, total: 0 },
                                'Mobile Erasure Verification': { amount: 0, price: 0, total: 0 },
                                'Mobile Diagnose': { amount: 0, price: 0, total: 0 },
                                'Mobile Check': { amount: 0, price: 0, total: 0 },
                                'Work Erasure': { amount: 0, price: 0, total: 0 },
                                'Work Erasure Verification': { amount: 0, price: 0, total: 0 },
                                'Work Diagnose': { amount: 0, price: 0, total: 0 },
                                'Work Check': { amount: 0, price: 0, total: 0 },
                                'Watch Erasure': { amount: 0, price: 0, total: 0 },
                                'Watch Diagnose': { amount: 0, price: 0, total: 0 },
                                'Watch Check': { amount: 0, price: 0, total: 0 },
                                'Headphone Diagnose': { amount: 0, price: 0, total: 0 },
                                'Headphone Check': { amount: 0, price: 0, total: 0 },
                                Remote: { amount: 0, price: 0, total: 0 },
                                Currency: { amount: 0, price: 0, total: 0 }
                            });
                            const unlimitedValues = [{ from: 0, to: null, price: 0 }];
                            setTopupPriceList({ mobile: unlimitedValues, mobile_diagnose: unlimitedValues, mobile_check: unlimitedValues, work: unlimitedValues, work_diagnose: unlimitedValues, work_check: unlimitedValues, remote: unlimitedValues, currency: unlimitedValues, work_verifier: unlimitedValues, mobile_verifier: unlimitedValues, mobile_erasure_lite: unlimitedValues, watch: unlimitedValues, watch_diagnose: unlimitedValues, watch_check: unlimitedValues, headphone_diagnose: unlimitedValues, headphone_check: unlimitedValues })
                        } else {
                            getTopUpPriceList();
                        }
                        handleChange(e)
                    }

                    if (!values['Mobile Erasure'].amount && !values['Mobile Erasure Lite'].amount && !values['Mobile Diagnose'].amount && !values['Mobile Check'].amount && !values['Work Diagnose'].amount && !values['Work Check'].amount && !values['Work Erasure'].amount && !values.Remote.amount && !values.Currency.amount && !values['Work Erasure Verification'].amount && !values['Mobile Erasure Verification'].amount && !values['Watch Erasure'].amount && !values['Watch Diagnose'].amount && !values['Watch Check'].amount && !values['Headphone Diagnose'].amount && !values['Headphone Check'].amount) {
                        setIsDisabled(true);
                    } else {
                        setIsDisabled(false);
                    }

                    return (
                        <div className={classes.root}>
                            <form onSubmit={handleSubmit} autoComplete="off">
                                <div className={classes.row}>
                                    <TopUpUnit name={'Work Erasure'} {...propsToPass} />
                                    <TopUpUnit name={'Work Erasure Verification'} {...propsToPass} />
                                    <TopUpUnit name={'Work Diagnose'} {...propsToPass} />
                                    <TopUpUnit name={'Work Check'} {...propsToPass} />
                                    <TopUpUnit name={'Mobile Erasure'} {...propsToPass} />
                                    <TopUpUnit name={'Mobile Erasure Lite'} {...propsToPass} />
                                    <TopUpUnit name={'Mobile Erasure Verification'} {...propsToPass} />
                                    <TopUpUnit name={'Mobile Diagnose'} {...propsToPass} />
                                    <TopUpUnit name={'Mobile Check'} {...propsToPass} />
                                    <TopUpUnit name={'Watch Erasure'} {...propsToPass} />
                                    <TopUpUnit name={'Watch Diagnose'} {...propsToPass} />
                                    <TopUpUnit name={'Watch Check'} {...propsToPass} />
                                    <TopUpUnit name={'Headphone Diagnose'} {...propsToPass} />
                                    <TopUpUnit name={'Headphone Check'} {...propsToPass} />
                                    <TopUpUnit name={'Remote'} {...propsToPass} />
                                    <TopUpUnit name={'Currency'} {...propsToPass} />

                                    {hasPermission(permissions, 'create_promotion_credits') ?
                                        <FormControlLabel control={
                                            <Checkbox
                                                checked={values.PromotionCredits} key={"PromotionCredits"}
                                                onChange={handlePromotionCredits}
                                                name={"PromotionCredits"} />}
                                            label={translations["promotion_credits"] || "Promotion credits"}
                                        /> : null
                                    }


                                    <div className={classes.buttons}>
                                        {error ? <p className={classes.error}>{translations['amount_error'] || "Amount must be whole number"}</p> :
                                            currencyError ? <p className={classes.error}>{translations['currency_error'] || "Money amount must not have more than 2 decimal places"}</p> : null}
                                        <div className={classes.buttonDiv}>
                                            {formSettings.ButtonCancel ? (
                                                <Button
                                                    className={classes.cancel}
                                                    variant="contained"
                                                    color={formSettings.ButtonCancel.Color}
                                                    onClick={formSettings.ButtonCancel.handleCancel}
                                                >
                                                    {formSettings.ButtonCancel.Title}
                                                </Button>
                                            ) : null}
                                            {formSettings.ButtonSubmit ? (
                                                <Button
                                                    className={classes.submit}
                                                    variant="contained"
                                                    color={formSettings.ButtonSubmit.Color}
                                                    type="submit"
                                                    disabled={!(isValid && dirty) || isSubmitting || isDisabled}
                                                >
                                                    {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                                </Button>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    );
                }}
            </Formik>}
            {loading && <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={loading}
                PaperProps={{
                    classes: {
                        root: classes.loadingScreen
                    }
                }}
            >
                <AppLogoLoading />
            </Dialog>}
        </>
    )
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onListTopupPriceList: params => dispatch(actions.fetchTopupPriceList(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(TopUpForm));
